app.service('warrantyQuestionnaire',function(localStorage, loading, modal) {

	function clearWarrantyQuestionnaire() {
		localStorage.removeItem('warrantyQuestionnaire');
	}
	function clearProductWarrantyQuestion(plu) {
		var warrantyQuestionnaireData = getWarrantyQuestionnaire();
		var answersData = warrantyQuestionnaireData.filter(function(answer) {
			return +answer.plu !== +plu;
		});
		if (answersData.length != 0) {
			localStorage.setItem('warrantyQuestionnaire', JSON.stringify(answersData));
		} else {
			clearWarrantyQuestionnaire();
		}
	}
	function getWarrantyQuestionnaire() {
		var warrantyQuestionnaireStorage = localStorage.getItem('warrantyQuestionnaire');
		return warrantyQuestionnaireStorage !== null ? JSON.parse(warrantyQuestionnaireStorage) : [];
	}
	function setWarrantyQuestionnaire(newAnswer) {
		var warrantyQuestionnaireData = getWarrantyQuestionnaire();
		//sprawdza czy odpowiedziano wczesniej na to pytanie
		var answeredBefore = warrantyQuestionnaireData.filter(function(answer) {
			return +answer.plu === +newAnswer.plu && +answer.questionId === +newAnswer.questionId;
		});

		if (!answeredBefore) {
			//brak wczesniejszej odpowiedzi na aktualne pytanie
			warrantyQuestionnaireData.push(newAnswer);
		} else {
			//zwraca liste bez aktualnego pytania
			var withoutAnswerBefore = warrantyQuestionnaireData.filter(function(answer) {
				return answer !== answeredBefore[0];
			});
			if (withoutAnswerBefore) {
				//zapisuje nowa odpowiedz na aktualne pytanie
				withoutAnswerBefore.push(newAnswer);
				warrantyQuestionnaireData = withoutAnswerBefore;
			}
		}
		localStorage.setItem('warrantyQuestionnaire', JSON.stringify(warrantyQuestionnaireData));
	}
	function markAnswers(modalId) {
		// zaznacza odpowiedzi na pytania ankietowe dla gwarancji przy produkcie na podstawie danych z localstorage
		var answersData = getWarrantyQuestionnaire();
		var $questions = modalId ? $(modalId + ' .warranties-questionnaire .warranty-question:visible') : $('.warranties-questionnaire .warranty-question:visible');
		if ($questions.length) {
			$questions.each(function() {
				var $radios = $(this).find('input[type="radio"]');
				var radioProductCode = $radios.eq(0).data('product-code');
				var matchedProducts = answersData.filter(function(item) {
					return +item.plu === +radioProductCode
				});
				if (matchedProducts.length) {
					$radios.each(function() {
						var radioData = {
							questionId:$(this).data('question-id'),
							answer:$(this).val()
						};
						var match = matchedProducts.filter(function(item) {
							return +item.questionId === +radioData.questionId
							&& item.answer === radioData.answer;
						});
						$(this).prop('checked', match.length != 0);
					});
				}
			});
		}
	}
	function updateWarrantyQuestionnaireBeforeSent() {
		// CHECKING FOR SELECTED WARRANTIES AND QUESTIONNAIRE IN BASKET
		var status = true;
		var $invalidQuestions = [];
		var $productsWarrantiesList = $('#cart-summarize .warranties');
		var $selectedWarranties = $productsWarrantiesList.find('.js-warranty-edit.selected');
		var data = [];
		if ($selectedWarranties.length != 0) {
			$productsWarrantiesList.each(function() {
				var mainCartItemId = $(this).find('.js-warranty-edit.selected').data('cart-id');
				var warrantyQuestions = $(this).find('.warranty-question');
				if(warrantyQuestions.length != 0){
					warrantyQuestions.each(function() {
						var $checkedAnswer = $(this).find('input[type=radio]:checked');
						if ($checkedAnswer.length != 0 && mainCartItemId) {
							data.push({
								mainCartItemId: mainCartItemId,
								answerNumber: $checkedAnswer.attr('name').slice($checkedAnswer.attr('name').length - 1)*1,
								answerValue: $checkedAnswer.val()
							});
						} else {
							if ($(this).closest('.warranties').find('.js-warranty-edit.selected').length != 0) {
								$invalidQuestions.push($(this).addClass('error'));
							}
						}
					});
				}
			});
			if ($invalidQuestions.length != 0) {
				$.scrollTo($invalidQuestions[0].closest('.warranties-questionnaire'));
				modal.alert('Uzupełnij odpowiedzi na pytania w ankiecie.');
				return false;
			}
	
			loading.start();
			$.ajax({
				url:'/cart-update-warranty-questionnaire.ltr',
				type: 'POST',
				dataType: 'json',
				contentType: 'application/json',
				data: JSON.stringify(data),
				success:function(json) {
					loading.stop();
					if (json.status == 'SUCCESS') {
						console.log('warranties saved');
						status = true;
					} else {
						modal.alert(json.messages[0]);
						status = false;
					}
				},
				error:function() {
					loading.stop();
					console.log('Nieudana próba wysłania ankiet.');
					status = false;
				}
			});
		}
		return status;
	}
	let isOneInit = false;
	function setEvents() {
		if(!isOneInit){
			isOneInit = true;
			$('body').on('click', '.warranties-questionnaire input[type="radio"]', function() {
				var newAnswer = {
					plu:$(this).data('product-code'),
					questionId:$(this).data('question-id'),
					answer:$(this).val(),
				}
				setWarrantyQuestionnaire(newAnswer);
			}).on('click', '.warranty-question.error input[type="radio"]', function() {
				$(this).closest('.warranty-question').removeClass('error');
			});
		}
	}
	function init() {
		markAnswers();
		setEvents();
	}
	return {
		init,
		getWarrantyQuestionnaire,
		clearWarrantyQuestionnaire,
		clearProductWarrantyQuestion,
		updateWarrantyQuestionnaireBeforeSent,
		markAnswers
	};
});
